/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_Last_TitleInputs */



/**
* | output |
* | --- |
* | "Go to last event" |
*
* @param {Video_Export_Preview_Go_To_Last_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_last_title = /** @type {((inputs?: Video_Export_Preview_Go_To_Last_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_Last_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au dernier evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum letzten Ereignis gehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'ultimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к последнему событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al último evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往上一个活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後のイベントへ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम कार्यक्रम पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o último evento")
	return /** @type {LocalizedString} */ ("Go to last event")
});